'use client';

import * as DS from '@aurorasolar/ds';
import Image, { type StaticImageData } from 'next/image';
import Link from 'next/link';

import { logoFamilyHandyman, logoGobankingrates, logoRealtor, logoYahooFinance, logoYahooShopping } from '../assets';

import { Section } from './Section';

const PRESS_LOGOS: { alt: string; src: StaticImageData; url: string }[] = [
  {
    alt: 'Yahoo! Finance',
    src: logoYahooFinance,
    url: 'https://finance.yahoo.com/news/trump-2026-energy-price-changes-130005279.html',
  },
  {
    alt: 'Family Handyman',
    src: logoFamilyHandyman,
    url: 'https://www.familyhandyman.com/article/clean-energy-tax-credit/',
  },
  {
    alt: 'GoBankingRates',
    src: logoGobankingrates,
    url: 'https://www.gobankingrates.com/money/economy/trump-2026-energy-price-changes-to-expect/',
  },
  {
    alt: 'realtor.com',
    src: logoRealtor,
    url: 'https://www.realtor.com/advice/home-improvement/plug-in-solar-utility-bills/',
  },
  {
    alt: 'Yahoo! Shopping',
    src: logoYahooShopping,
    url: 'https://shopping.yahoo.com/home-garden/home-improvement/articles/survey-reveals-homeowners-racing-install-070000778.html',
  },
];

export const PressLogos = () => (
  <Section align="center">
    <DS.Flex flexDirection="row" flexWrap="wrap" gap={9} justifyContent="center">
      {PRESS_LOGOS.map(({ alt, src, url }) => (
        <Link href={url} key={url} rel="noopener noreferrer" style={{ width: 140 }} target="_blank">
          <Image alt={alt} height={32} src={src} style={{ objectFit: 'contain' }} width={140} />
        </Link>
      ))}
    </DS.Flex>
  </Section>
);
